module.exports = __webpack_public_path__ + "static/media/support.32cd3ed6.svg";